module.exports = __webpack_public_path__ + "img/avatar7.e3affd58.png";